export const containerWidth = 1366

export enum MaxWidthByDevice {
	MobileExtraSmall = 320,
	MobilePortrait = 560,
	Mobile = 768,
	Tablet = 1024,
	Laptop = 1200
}

export const mediaQueriesByDevice = {
	mobileExtraSmall: `@media (max-width: ${[MaxWidthByDevice.MobileExtraSmall]}px)`,
	mobilePortrait: `@media (max-width: ${[MaxWidthByDevice.MobilePortrait]}px)`,
	mobile: `@media (max-width: ${[MaxWidthByDevice.Mobile]}px)`,
	tablet: `@media (max-width: ${[MaxWidthByDevice.Tablet]}px)`,
	laptop: `@media (max-width: ${[MaxWidthByDevice.Laptop]}px)`
}
